<app-home-header></app-home-header>
<div class="wrapper col">
  <div class="headerrow row space-between w100" *ngIf="showGreets">
    <div class="col gap-8">
      <h1 i18n>
        Welcome<span *ngIf="name != ''">, {{ name }}!</span> 👋
      </h1>
      <h4 i18n>A great day to disrupt the world with your administration!</h4>
    </div>
    <rr-icon name="close" class="pointer" (click)="closeGreet()"></rr-icon>
  </div>
  <rr-menue *ngIf="showMenue"></rr-menue>
  <router-outlet></router-outlet>
</div>
